import { INVENTORY_COUNT_PENDING, INVENTORY_COUNT_CANCELED, INVENTORY_COUNT_COMPLETE } from '@/utils/statuses/inventory-count'
import { INVENTORY_COUNT_PARTIAL, INVENTORY_COUNT_FULL, INVENTORY_COUNT_INCOMING } from '@/utils/types/inventory-count'

const inventoryCountInfoMixin = {
  methods: {
    isPending (item) {
      return item.status === INVENTORY_COUNT_PENDING
    },
    isCanceled (item) {
      return item.status === INVENTORY_COUNT_CANCELED
    },
    isComplete (item) {
      return item.status === INVENTORY_COUNT_COMPLETE
    },

    isPartial (item) {
      return item.type === INVENTORY_COUNT_PARTIAL
    },
    isFull (item) {
      return item.type === INVENTORY_COUNT_FULL
    },
    isIncoming (item) {
      return item.type === INVENTORY_COUNT_INCOMING
    }
  }
}

export default inventoryCountInfoMixin



// WEBPACK FOOTER //
// ./src/utils/mixins/inventoryCountInfoMixin.js